<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icontongzhi"></i>
      {{ id ? '通知编辑' : '通知新增' }}
    </div>
    <div class="padding-sm">

      <el-form :model="noticeForm" :rules="rules" ref="noticeForm" label-width="100px" class="demo-noticeForm">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="noticeForm.title" placeholder="请输入通知标题"></el-input>
        </el-form-item>
        <el-form-item label="通知文本" prop="content">
          <VueUditorWrap v-model="noticeForm.content" :config="myConfig"></VueUditorWrap>
        </el-form-item>
        <el-form-item label="发送给谁" prop="org">
          <div class="flex align-starts" style="height: 80px;">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <span class="padding-right"></span>
            <el-checkbox-group v-model="noticeForm.org" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item,index) in orgArr" :label="item.value" :key="index">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </div>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm('noticeForm')">提交</el-button>
          <el-button class="submit-btn" @click="back">返回</el-button>
        </el-form-item>
      </el-form>


    </div>
  </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import { msgAdd, msgOne} from "@/api/projectOffice";
import {bdEditConfig} from "@/tools/utils";
export default {
  name: "noticeAdd",
  components: {VueUditorWrap},
  data() {
    return {
      id: '',
      typeArr: {},
      isIndeterminate: false,
      checkAll: false,
      orgArr: [
        {value: 2, name: '认证培训机构'},
        {value: 3, name: '实习基地'},
        {value: 4, name: '考场'},
        {value: 5, name: '产教融合基地'},
        {value: 7, name: '培训协调中心'},
        {value: 8, name: '实习协调中心'},
        {value: 9, name: '考场协调中心'},
        {value: 10, name: '教学协调中心'},
      ],
      noticeForm: {
        title: '',
        type: '',
        content: '',
        org: []
      },

      rules: {
        title: [
          {required: true, message: '请输入通知标题', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入通知文本', trigger: 'blur'},
        ],
        org: [
          {required: true, message: '请选择发送给谁', trigger: 'change'},
        ],
      },


      detail: '',
      myConfig: bdEditConfig()
    }
  },
  created() {
    this.id = this.$route.query.id
    this.$emit(
        "setIndex",
        '/projectOffice/notice',
        "当前位置：通知管理 > <span>" + (this.id ? '通知编辑' : '通知新增') + "</span> ",
        true
    );
    if (this.id) this.getDetail()
  },
  methods: {
    async getDetail() {
      let _data = await msgOne(this.id)
      let _arr = _data.data.org_types.split(',')
      let _arr2 = []
      _arr.map(item=>{
        _arr2.push(Number(item))
      })
      this.noticeForm = {
        title: _data.data.msg_title,
        content: _data.data.msg_content,
        org: _arr2
      }
      this.handleCheckedCitiesChange(_arr2)
    },
    handleCheckAllChange(val) {
      this.noticeForm.org = val ? [2, 3, 4, 5,7,8,9,10] : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.orgArr.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.orgArr.length;
    },
    back() {
      this.$router.go(-1)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitNotice()
        }
      });
    },
    async submitNotice() {
      let _state = await msgAdd(this.noticeForm.title, this.noticeForm.content, this.noticeForm.org.join(','), this.id)
      this.$message.success(_state.msg)
      this.back()
    }
  }
}
</script>

<style scoped lang="scss">

</style>